module.exports = __webpack_public_path__ + "static/img/ks1.c559c31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/ks1.png
// module id = bUpY
// module chunks = 19